import { postRequest } from "../app/postRequest.service";
import { kycDetailsWithMAIDsReqPayload, kycDetailsWithMAIDsResponse } from "../interfaces/familyMemberDetails.interface";
import { RouteConstant } from "../common/common.constants";

export function kycDetailsApi(req: kycDetailsWithMAIDsReqPayload){
  return new Promise<{data: kycDetailsWithMAIDsResponse}>((resolve) => 
    resolve(postRequest(RouteConstant.KYC_DETAIL_WITH_MAID,req))
  )
}
